"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var normalizeCarouselMedia = function (medias) {
    return medias.map(function (media) { return ({
        type: media.type,
        url: media.url,
        videoPosterUrl: media.video_poster_url,
        cloudflareId: media.cloudflare_id,
        youtubeId: media.youtube_id,
        openInPopup: media.open_in_popup,
    }); });
};
exports.default = normalizeCarouselMedia;
